var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27 40h6v6h-6z",
    fill: "#35495e"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#547580",
    height: 18,
    rx: 9,
    width: 58,
    x: 1,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#95a5a5",
    height: 10,
    rx: 5,
    width: 24,
    x: 18,
    y: 45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 32,
    fill: "#b0d3f0",
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 32,
    fill: "#4482c3",
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 35h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2z",
    fill: "#7ed09e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 35h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2z",
    fill: "#7ed09e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 37a5 5 0 0 1 -4.331-7.5 1 1 0 0 1 1.731 1 3 3 0 1 0 5.2 0 1 1 0 0 1 1.731-1 5 5 0 0 1 -4.331 7.5z",
    fill: "#ff5364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 31a1 1 0 0 1 -1-1v-2a1 1 0 0 1 2 0v2a1 1 0 0 1 -1 1z",
    fill: "#ff5364"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3b97d3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23 15h-3v-7a1 1 0 0 0 -2 0v8a1 1 0 0 0 1 1h4a1 1 0 0 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 7a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-8a1 1 0 0 0 -1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.351 7.063a1 1 0 0 0 -1.288.585l-2.063 5.504-2.063-5.5a1 1 0 0 0 -1.874.7l3 8a1 1 0 0 0 1.874 0l3-8a1 1 0 0 0 -.586-1.289z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 9a1 1 0 0 0 0-2h-3a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h3a1 1 0 0 0 0-2h-2v-2h2a1 1 0 0 0 0-2h-2v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.046 7.394a1 1 0 0 0 -1.414-1.415 9.01 9.01 0 0 0 0 12.728 1 1 0 0 0 1.414-1.414 7.008 7.008 0 0 1 0-9.899z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.875 8.808a1 1 0 0 0 -1.414 0 5 5 0 0 0 0 7.071 1 1 0 0 0 1.414-1.414 3 3 0 0 1 0-4.243 1 1 0 0 0 0-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.368 5.979a1 1 0 0 0 -1.414 1.415 7.008 7.008 0 0 1 0 9.9 1 1 0 1 0 1.414 1.414 9.01 9.01 0 0 0 0-12.729z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.539 8.808a1 1 0 0 0 -1.414 1.414 3 3 0 0 1 0 4.243 1 1 0 1 0 1.414 1.414 5 5 0 0 0 0-7.071z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveVideos);
export default __webpack_public_path__ + "static/media/live-videos.8108cfe0fe7c48ab5fb01adc98950549.svg";
export { ForwardRef as ReactComponent };